var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-checkmark-circle-outline';
                    var viewUrl = 'gfx/sprite.svg#view-icon-checkmark-circle-outline';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };